import { MetricArrayType, OfferDto, VariationDto } from "@intelligems/ig-types";

import { toGqlId } from "../api/formatters/shopify";
import { Product } from "../generated";
import { AnalyticsSubMenu } from "../types/navigation";

import { SelectedProduct } from "./types/productPicker";

export const getInitialControl = (
  variations: VariationDto[],
  pageName: string
) => {
  if (pageName !== AnalyticsSubMenu.Overview) {
    return undefined;
  }

  const controlGroup = variations.find((group) => group.isControl);
  return controlGroup!.id;
};

export const getDefaultCompareGroup = (
  variations: VariationDto[],
  controlVariation: VariationDto,
  page: string,
  dashboardData: MetricArrayType | undefined,
  shouldShowProfit: boolean
) => {
  if (page !== AnalyticsSubMenu.Overview) {
    return undefined;
  }

  if (dashboardData) {
    let maxMetricPerUserIndex = -1;
    let maxMetricPerUser = -1;

    if (controlVariation) {
      if (shouldShowProfit) {
        dashboardData.forEach((metric, index) => {
          if (
            controlVariation.id !== metric["VARIATION_ID"] &&
            Number(metric["PROFIT_PER_VISITOR"]) > maxMetricPerUser
          ) {
            maxMetricPerUserIndex = index;
            maxMetricPerUser = metric["PROFIT_PER_VISITOR"] as number;
          }
        });
      } else {
        dashboardData.forEach((metric, index) => {
          if (
            controlVariation.id !== metric["VARIATION_ID"] &&
            Number(metric["REV_PER_VISITOR"]) > maxMetricPerUser
          ) {
            maxMetricPerUserIndex = index;
            maxMetricPerUser = metric["REV_PER_VISITOR"] as number;
          }
        });
      }
    }

    if (maxMetricPerUserIndex > -1) {
      const chosenGroup = dashboardData[maxMetricPerUserIndex];
      return chosenGroup!["VARIATION_ID"] as string;
    } else {
      const defaultGroup = variations.find((group) => !group.isControl);
      return defaultGroup!.id;
    }
  } else return undefined;
};

export const getOfferIndexByVariationId = (
  draftOffers: OfferDto[],
  variationId: string
) => {
  let index = 0;

  const foundIndex = draftOffers.findIndex(
    (findOffer) => findOffer.variationId === variationId
  );
  if (foundIndex > -1) {
    index = foundIndex;
  }
  return index;
};

export const filteredSelectionCount = (
  products: (Product | SelectedProduct)[],
  selectedProducts: (Product | SelectedProduct)[]
) => {
  return products.reduce((prev: number, current: Product | SelectedProduct) => {
    return (
      prev +
      (selectedProducts.some(
        (selProd) =>
          toGqlId(selProd.id, "Product") === toGqlId(current.id, "Product")
      )
        ? 1
        : 0)
    );
  }, 0);
};
